export default __webpack_public_path__ + "static/media/character-obara-kashin.701b3a7a.png";